// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  padding: 1rem;
  box-sizing: border-box;
}

.popup-content {
  width: 90%;
  max-width: 400px;
  background-color: var(--background);
  border-radius: 1rem;
  padding: 1rem;
  position: relative;
  display: grid;
  grid-template-rows: auto auto 1fr auto;
  gap: 0.5rem;
  height: auto;
  max-height: 90vh;
  text-align: center;
}

.popup-content h2 {
  margin: 0;
  font-size: clamp(2.4rem, 4vw, 1.5rem);
}

.popup-content h3 {
  margin: 0;
  font-size: clamp(1.6rem, 3vw, 1.2rem);
}

.popup-poster {
  width: auto;
  height: auto;
  max-height: 45vh;
  object-fit: contain;
  border-radius: 0.5rem;
  margin: 0.5rem auto;
}

.matched-friend {
  font-size: clamp(1.4rem, 3vw, 1.2rem);
  font-weight: bold;
  margin: 0.25rem 0;
  color: var(--text-primary);
}

.matched-button-container {
  display: flex;
  gap: 1rem;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
}

.watch-now,
.no-thanks {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-size: clamp(0.875rem, 3vw, 1rem);
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: transform 0.2s ease;
  min-width: 120px;
}

.watch-now:active,
.no-thanks:active {
  transform: scale(0.95);
}

.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 9998;
}

.matched-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9997;
}

.matched-button-container {
  display: flex;
  gap: 0.75rem;
  padding: 0.5rem;
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
}

.watch-now,
.no-thanks {
  flex: 1 1;
  padding: 0.75rem;
  border: none;
  border-radius: 0.5rem;
  font-size: clamp(1.25rem, 2.5vw, 1rem);
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 100px;
  max-width: 150px;
}

.watch-now {
  background-color: #28a745;
  color: white;
}

.no-thanks {
  background-color: #dc3545;
  color: white;
}

/* Mobile-specific adjustments */
@media (max-width: 480px) {
  .popup-content {
    width: 95%;
    padding: 0.75rem;
  }

  .popup-poster {
    max-height: 40vh;
  }

  .matched-button-container {
    padding: 0.25rem;
  }

  .watch-now,
  .no-thanks {
    padding: 0.5rem;
  }
}

/* Very small screens */
@media (max-height: 600px) {
  .popup-poster {
    max-height: 35vh;
  }

  .popup-content {
    gap: 0.25rem;
  }
}

/* Animation classes */
.matched-popup-enter {
  opacity: 0;
  transform: scale(0.9);
}

.matched-popup-enter-active {
  opacity: 1;
  transform: scale(1);
  transition: opacity 300ms, transform 300ms;
}

.matched-popup-exit {
  opacity: 1;
}

.matched-popup-exit-active {
  opacity: 0;
  transition: opacity 300ms;
}
`, "",{"version":3,"sources":["webpack://./src/assets/MatchNotifications.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.85);\n  z-index: 9999;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.popup-content {\n  width: 90%;\n  max-width: 400px;\n  background-color: var(--background);\n  border-radius: 1rem;\n  padding: 1rem;\n  position: relative;\n  display: grid;\n  grid-template-rows: auto auto 1fr auto;\n  gap: 0.5rem;\n  height: auto;\n  max-height: 90vh;\n  text-align: center;\n}\n\n.popup-content h2 {\n  margin: 0;\n  font-size: clamp(2.4rem, 4vw, 1.5rem);\n}\n\n.popup-content h3 {\n  margin: 0;\n  font-size: clamp(1.6rem, 3vw, 1.2rem);\n}\n\n.popup-poster {\n  width: auto;\n  height: auto;\n  max-height: 45vh;\n  object-fit: contain;\n  border-radius: 0.5rem;\n  margin: 0.5rem auto;\n}\n\n.matched-friend {\n  font-size: clamp(1.4rem, 3vw, 1.2rem);\n  font-weight: bold;\n  margin: 0.25rem 0;\n  color: var(--text-primary);\n}\n\n.matched-button-container {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.watch-now,\n.no-thanks {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: clamp(0.875rem, 3vw, 1rem);\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: transform 0.2s ease;\n  min-width: 120px;\n}\n\n.watch-now:active,\n.no-thanks:active {\n  transform: scale(0.95);\n}\n\n.confetti-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 9998;\n}\n\n.matched-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9997;\n}\n\n.matched-button-container {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.5rem;\n  width: 100%;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.watch-now,\n.no-thanks {\n  flex: 1;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: clamp(1.25rem, 2.5vw, 1rem);\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-width: 100px;\n  max-width: 150px;\n}\n\n.watch-now {\n  background-color: #28a745;\n  color: white;\n}\n\n.no-thanks {\n  background-color: #dc3545;\n  color: white;\n}\n\n/* Mobile-specific adjustments */\n@media (max-width: 480px) {\n  .popup-content {\n    width: 95%;\n    padding: 0.75rem;\n  }\n\n  .popup-poster {\n    max-height: 40vh;\n  }\n\n  .matched-button-container {\n    padding: 0.25rem;\n  }\n\n  .watch-now,\n  .no-thanks {\n    padding: 0.5rem;\n  }\n}\n\n/* Very small screens */\n@media (max-height: 600px) {\n  .popup-poster {\n    max-height: 35vh;\n  }\n\n  .popup-content {\n    gap: 0.25rem;\n  }\n}\n\n/* Animation classes */\n.matched-popup-enter {\n  opacity: 0;\n  transform: scale(0.9);\n}\n\n.matched-popup-enter-active {\n  opacity: 1;\n  transform: scale(1);\n  transition: opacity 300ms, transform 300ms;\n}\n\n.matched-popup-exit {\n  opacity: 1;\n}\n\n.matched-popup-exit-active {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
